<template>
  <main class="content">
    <div class="content__heading content__heading--center">
      <h1>{{ $t('home.welcome', { name: user.name}) }}</h1>
    </div>

    <section class="dashboard">
      <button type="button" class="btn btn--big btn--center dashboard__add" @click="show">
        <i class="icon--plus"></i>&nbsp;
        <span class="hide--mobile"> {{ $t('fusebox.add_new') }}</span>
        <span class="show--mobile"> {{ $t('general.create') }}</span>
      </button>
      <!--      <ModalButton text="Open Modal" modal="TestModal"/>-->

      <div class="dashboard__grid">

        <div class="dashboard__grid__row--hero dashboard__grid__row">

          <div class="dashboard__grid__cell--hero dashboard__grid__cell">
            <div class="dashboard__grid__cell__heading">
              <h2>{{ $t('home.qr_code_in') }} {{ new Date() | moment('MMMM') }}</h2>
            </div>
            <div>{{ counts.scanCurrent | formatNumber }}</div>
          </div>

          <div class="dashboard__grid__cell--hero dashboard__grid__cell">
            <div class="dashboard__grid__cell__heading">
              <h2>{{ $t('home.total_fsb') }}</h2>
            </div>
            <div>{{ counts.fusebox | formatNumber }}</div>
          </div>

          <div class="dashboard__grid__cell--hero dashboard__grid__cell">
            <div class="dashboard__grid__cell__heading">
              <h2>{{ $t('home.qr_code') }}</h2>
            </div>
            <div>{{ counts.scan | formatNumber }}</div>
          </div>

        </div>

        <div class="dashboard__grid__row">
          <Panel :title="$t('general.users')" :icon="'users'" :button-text="$t('home.add_users')"
                 :button-icon="'icon--plus'"
                 :count="counts.user" :add-text="$t('home.you')"
                 :button="() => sendTo('user.index')">
            <template v-slot:body>

              <h4>{{ $t('general.lastEdit') }}</h4>

              <div class="table table--small">
                <div class="table--small__row" v-for="user in latest.users" :key="user.uuid">
                  <div class="table--small__row__content" @click="sendToEdit('user.index', user.uuid, 'users')"><i
                    class="icon--user"></i>
                    {{ user.name }}
                  </div>
                </div>

                <div class="table--small__row table--small__row--extra" @click="linkTo('user.index')">
                  <div class="table--small__row__content">
                    <i class="icon--users"></i> {{ $t('general.all_users') }}
                  </div>
                </div>
              </div>
            </template>
          </Panel>

          <Panel :button="() => show()" :button-text="$t('fusebox.add_new')"
                 :button-icon="'icon--plus'"
                 :count="counts.label"
                 :title="$t('general.fuseboxes')" :icon="'list'">
            <template v-slot:body>

              <h4>{{ $t('general.lastEdit') }}</h4>

              <div class="table table--small">
                <div class="table--small__row" v-for="fusebox in latest.fuseboxes" :key="fusebox.uuid">
                  <div class="table--small__row__content" @click="linkTo('fusebox.single.index', fusebox.uuid)"><i
                    class="icon--list"></i>
                    {{ fusebox.name }}
                  </div>
                </div>

                <div class="table--small__row table--small__row--extra" @click="linkTo('fusebox.index')">
                  <div class="table--small__row__content">
                    <i class="icon--list"></i> {{ $t('general.all_fuseboxes') }}
                  </div>
                </div>
              </div>
            </template>
          </Panel>

          <Panel v-if="false" :button="() => sendTo('location.index')" :button-text="$t('home.add_location')"
                 :button-icon="'icon--plus'"
                 :count="counts.location"
                 :title="$t('general.locations')">
            <template v-slot:body>

              <h4>{{ $t('general.lastEdit') }}</h4>

              <div class="table table--small">
                <div class="table--small__row" v-for="location in latest.locations" :key="location.uuid">
                  <div class="table--small__row__content"
                       @click="sendToEdit('location.index', location.uuid, 'locations')"><i
                    class="icon--location"></i>
                    {{ location.name }}
                  </div>
                </div>

                <div class="table--small__row table--small__row--extra" @click="linkTo('location.index')">
                  <div class="table--small__row__content">
                    <i class="icon--location"></i> {{ $t('general.all_locations') }}
                  </div>
                </div>
              </div>
            </template>
          </Panel>

        </div>

        {{ menuItems }}

        <div class="dashboard__grid__row">

          <div class="dashboard__grid__cell--boxed dashboard__grid__cell">

            <div class="dashboard__grid__cell__heading">
              <h2><i class="icon--history"></i> {{ $t('general.history') }}
                <small>({{ $t('fusebox.lastNth', {
                  historyItems: activities.length > activityItems ? activityItems : activities.length })
                  }})</small></h2>
            </div>

            <div class="table table--badged" v-if="activities.length">

              <div class="table--badged__row" v-for="(activity, i) in activities.slice(0, activityItems)" :key="i">

                <div class="table--badged__badge" :data-icon="activity.description"></div>
                <div class="table--badged__description table--badged__description--full">
                  <h3>
                    {{ $t(`home.subject.${activity.subject_type.toLowerCase()}`) }}
                    {{ $t(`home.history.${activity.description.toLowerCase()}`) }} - {{ activity.property }}
                  </h3>
                  <small>

                    <span class="table--badged__description__item" v-if="activity.created_at !== 'undefined'"><i
                      class="icon--calendar"></i> {{ activity.created_at | moment('MMM D YYYY, HH:mm') }}</span>
                    <span class="table--badged__description__item" v-if="activity.causer_id !== null"><i
                      class="icon--user"></i> {{ activity.name }}
                    </span>
                  </small>
                </div>
              </div>

            </div>
            <div class="message" v-else>
              {{ $t('messages.noHistory') }}
            </div>

          </div>

        </div>

      </div>

    </section>

    <NewFusebox @hideModal="hide" @init="init"/>
    <AddFusebox @hideModal="hide" @init="init"/>

  </main>

</template>

<script>
import NewFusebox from '@/components/Modal/NewFusebox'
import AddFusebox from '@/components/Modal/AddFusebox'
import Panel from '@/components/Parts/Panel'
import { mapGetters } from 'vuex'

export default {
  name: 'Dashboard',
  components: {
    NewFusebox,
    AddFusebox,
    Panel
  },
  async mounted () {
    await this.init()
  },
  data () {
    return {
      menuItems: this.menuitems,
      activityItems: 5,
      tag: '',
      tags: [],
      locations: [],
      labels: [],
      form: {
        name: '',
        location_id: '',
        labels: []
      }
    }
  },
  computed: {
    ...mapGetters({
      counts: 'dashboard',
      activities: 'activities',
      latest: 'latest'
    })
  },
  filters: {
    formatNumber (value) {
      return new Intl.NumberFormat('nl-NL', { style: 'decimal' }).format(value)
    }
  },
  methods: {
    async init () {
      await this.$store.dispatch('dashboardInit')
    },
    show () {
      this.$modal.show('Fusebox-Group')
    },
    hide () {
      this.$modal.hide('Fusebox-Group')
    },
    sendTo (path) {
      this.$router.push({ name: path, query: { open: 1 } })
    },
    sendToEdit (path, id, type) {
      if (this.$can('edit', type)) {
        this.$router.push({ name: path, query: { edit: id } })
      }
    },
    linkTo (path, id = null) {
      if (id !== null) {
        this.$router.push({ name: path, params: { id: id } })
      } else {
        this.$router.push({ name: path })
      }
    }
  }
}
</script>
